import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const UserManagementView = loadView('user-management/UserManagementView');

const userManagementRoute = {
  path: ROUTE.PATH.USER_MANAGEMENT,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.USER_MANAGEMENT,
      component: UserManagementView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: ROUTE.PATH.USER_MANAGEMENT,
      name: ROUTE.NAME.USER_MANAGEMENT,
      component: UserManagementView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
  ],
};

export default userManagementRoute;
